export default "__VITE_ASSET__0d30b220__"